import axios from 'axios'
import { cnpj as validadorCNPJ, cpf as validadorCPF} from 'cpf-cnpj-validator';
import moment from 'moment';
import { validate } from 'email-validator';
const Swal = require('sweetalert2')
const jwt_decode = require('jwt-decode');


//let isProd = process.env.NODE_ENV === 'production'
let isProd = true;
axios.defaults.baseURL = (isProd) ? 'https://api.maxcompliance.com.br/api' : 'http://127.0.0.1:8000/api'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.timeout = 120000;

const corConfirmacao = "#01AA5D"

axios.interceptors.request.use(async (config) => {
     if (
      !config.url.endsWith('login')
      || !config.url.includes('viacep.com.br')
     ) {
         let token = localStorage.getItem("token_max");
         config.headers.Authorization = (token) ? `Bearer ${token}` : '';
     }

     return config;
   }, (error) => {
      //I cand handle a request with errors here
     return Promise.reject(error);
   });

export async function ajax(metodo, url, pacote, headers = null){
    let info;
    await axios[metodo](url, pacote,headers)
    .then(response => {
        info = response.data
    })
    return info
}

export async function confirma(title, message, confirmMessage) {
    let response = await Swal.fire({
        title: title ? title : 'Você tem certeza?',
        text: message ? message: "Essa ação não pode ser desfeita",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: confirmMessage ? confirmMessage : 'Sim, desejo remover!'
    })

    if(response.value) {
        return true;
    } else {
        return false;
    }
}

export async function confirmaSoft(message, title, confirmMessage) {
    let response = await Swal.fire({
        text: message ? message: 'Você tem certeza?',
        title: title ? title : 'Atenção!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: confirmMessage ? confirmMessage : 'Sim, desejo desativar!'
    })

    if(response.value) {
        return true;
    } else {
        return false;
    }
}

export function alerta(type, title, message){
    Swal.fire({
        position: "center",
        type: type,
        title: title,
        text: message,
        showConfirmButton: true,
        confirmButtonColor: corConfirmacao,
    });
}

export function tratamento_requisicao(error){

    if(error.response == undefined){
        Swal.fire({
            position: "center",
            type: "error",
            title: "Erro interno do servidor",
            text: "Não identificamos o erro, por favor tente novamente!",
            showConfirmButton: true,
            confirmButtonColor: corConfirmacao,
        });
    }
    let switchIndex = (error.response.status) ? error.response.status : 1;
    switch(switchIndex){
                case 400:
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: (error.response.data.title) ? error.response.data.title : 'Solicitação Inválida',
                        text: error.response.data.message,
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                case 500:
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: (error.response.data.title) ? error.response.data.title : 'Erro no servidor',
                        text: error.response.data.message,
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                case 404:
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: (error.response.data.title) ? error.response.data.title : 'Solicitação Inválida',
                        text: error.response.data.message,
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                case 401:
                    localStorage.removeItem("token_max")
                    Swal.fire({
                        position: "center",
                        type: "warning",
                        title: (error.response.data.title) ? error.response.data.title : 'Não autorizado',
                        text: error.response.data.message,
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                case 408:
                    Swal.fire({
                        position: "center",
                        type: "warning",
                        title: 'Tempo de solicitação esgotado',
                        text: 'Requisição está demorando demais, tente novamente!',
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                default:
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: "Erro inesperado",
                        text: "Não identificamos o erro, por favor tente novamente!",
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
            }
}

export function verificaSeEstaLogado(){
    var token = localStorage.getItem("token_max");
    if(token){
        let tokenDecode = jwt_decode(token);
        return tokenDecode
    }else
        return false
}

export function validaCampos(email, cnpj, telefone, cpf){
    if (email != undefined) {
        if(validate(email) == false ) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "E-mail Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
        }
      }

      if (cnpj != undefined) {
        if(validadorCNPJ.isValid(cnpj) == false) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "CNPJ Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
        }
      }

      if(telefone != undefined) {
        const tel = telefone.replace(/\D/g, "");
        if(tel.length < 10) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "Telefone Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
        }
      }

      if(cpf != undefined) {
          if(validadorCPF.isValid(cpf) == false) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "CPF Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
          }
      }

      return true;
}

export function stripCPF(cpf){
    return validadorCPF.strip(cpf);
}

export function stripCNPJ(cnpj) {
	return validadorCNPJ.strip(cnpj)
}

export function stripTelefone(tel) {
	return tel
	.replaceAll('(', '')
	.replaceAll(')', '')
	.replaceAll(' ', '')
	.replaceAll('-', '')
}

export function padronizaHora(horario) {
    return moment.utc(horario).format("HH:mm")
}

export function confereSenha(senha, confirmacaoSenha) {
    if(senha == confirmacaoSenha) return true;
    else {
        Swal.fire({
            position: "center",
            type: "warning",
            title: "As senhas não conferem",
            text: "Por favor, confira se ambas as senhas são identicas e tente novamente",
            showConfirmButton: true,
            confirmButtonColor: corConfirmacao,
        });

        return false;
    }
}

export function criaFormData(objeto) {
    let objRequest = new FormData();
    for(let key in objeto) {
        objRequest.append(key, objeto[key]);
    }
    return objRequest;
}

export function padronizaData(data) {
    return data ? moment(String(data)).format("DD/MM/YYYY") : "";
}

export function formataTimestamp(timestamp) {
    const hora = padronizaHora(timestamp);
    const data = padronizaData(timestamp);
    return `${data} às ${hora}`;
}

export function checarObjeto(obj) {
    for (let key in obj) {
        if (obj[key] == null || obj[key] == "") {
            return false;
        }
    }
    return true;
}
